<template>
    <section class="features-split section" :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div class="features-split-inner section-inner" :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <c-section-header :data="sectionHeader" class="center-content" />
                <div class="split-wrap" :class="[
                        invertMobile && 'invert-mobile',
                        invertDesktop && 'invert-desktop',
                        alignTop && 'align-top'
                    ]">
                    <div class="split-item">
                        <div class="split-item-content center-content-mobile">
                            <h3 class="mt-0 mb-16 reveal-from-left" data-reveal-container=".split-item">
                                {{ $t('cows-are-in-barns-a-lot') }}
                            </h3>
                            <p class="m-0 reveal-from-left" data-reveal-container=".split-item" data-reveal-delay="100">
                                {{ $t('they-are-fed-stay-dry') }}
                            </p>
                        </div>
                        <div class="split-item-image illustration-element-02" data-reveal-container=".split-item"
                            data-reveal-delay="200" :class="imageFill && 'split-item-image-fill'">
                            <c-image :src="require('@/assets/images/features-split-image.svg')"
                                alt="Features split image 01" :width="528" :height="396" />
                            <div style="position:absolute;width:118.18%;max-width:118.18%;top:-7.07%;left:-9.09%;">
                                <c-image :src="require('@/assets/images/struvital-images/pexels-cottonbro-4910828.jpg')"
                                    alt="Features split top 01" :width="654" :height="522" />
                            </div>
                        </div>
                    </div>

                    <div class="split-item">
                        <div class="split-item-content center-content-mobile">
                            <h3 class="mt-0 mb-16 reveal-from-right" data-reveal-container=".split-item">
                                {{ $t('we-convert-thei') }}
                            </h3>
                            <p class="m-0 reveal-from-right" data-reveal-container=".split-item"
                                data-reveal-delay="100">
                                {{ $t('struvite-is-a-s') }}
                            </p>
                        </div>
                        <div class="split-item-image illustration-element-03 reveal-scale-down"
                            data-reveal-container=".split-item" data-reveal-delay="200"
                            :class="imageFill && 'split-item-image-fill'">
                            <c-image :src="require('@/assets/images/features-split-image.svg')"
                                alt="Features split image 02" :width="528" :height="396" />
                            <div style="position:absolute;width:118.18%;max-width:118.18%;top:10.07%;left:-9.09%;">
                                <c-image
                                    :src="require('@/assets/images/struvital-images/ride-out.jpg')"
                                    alt="Features split top 02" :width="654" :height="521" />
                            </div>
                        </div>
                    </div>

                    <div class="split-item">
                        <div class="split-item-content center-content-mobile">
                            <h3 class="mt-0 mb-16 reveal-from-left" data-reveal-container=".split-item">
                                {{ $t('the-land-benefi') }}
                            </h3>
                            <p class="m-0 reveal-from-left" data-reveal-container=".split-item" data-reveal-delay="100">
                                {{ $t('it-reduces-the-') }} </p>
                        </div>
                        <div class="split-item-image illustration-element-04 reveal-scale-down"
                            data-reveal-container=".split-item" data-reveal-delay="200"
                            :class="imageFill && 'split-item-image-fill'">
                            <c-image :src="require('@/assets/images/features-split-image.svg')"
                                alt="Features split image 03" :width="528" :height="396" />
                            <div style="position:absolute;width:118.18%;max-width:118.18%;top:-7.07%;left:-9.09%;">
                                <c-image :src="require('@/assets/images/struvital-images/pexels-pixabay-158827.jpg')"
                                    alt="Features split top 03" :width="654" :height="436" />
                            </div>
                        </div>
                    </div>

                    <div class="split-item">
                        <div class="split-item-content center-content-mobile">
                            <h3 class="mt-0 mb-16 reveal-from-right" data-reveal-container=".split-item">
                                {{ $t('our-first-produ') }}
                            </h3>
                            <p class="m-0 reveal-from-right" data-reveal-container=".split-item"
                                data-reveal-delay="100">
                                {{ $t('easy-to-use-sec') }}
                            </p>
                        </div>
                        <div class="split-item-image illustration-element-03 reveal-scale-down"
                            data-reveal-container=".split-item" data-reveal-delay="200"
                            :class="imageFill && 'split-item-image-fill'">
                            <c-image :src="require('@/assets/images/features-split-image.svg')"
                                alt="Features split image 02" :width="528" :height="396" />
                            <div style="position:absolute;width:65%;max-width:118.18%;top:-7.07%;left:15.00%;">
                                <c-image :src="require('@/assets/images/struvital-images/deployment-2.jpg')"
                                    alt="Features split top 02" :width="654" :height="521" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionSplitProps } from '@/utils/SectionProps.js'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
import CImage from '@/components/elements/Image.vue'

export default {
  name: 'CFeaturesSplit',
  components: {
    CSectionHeader,
    CImage
  },
  mixins: [SectionSplitProps],
  data() {
    return {
      sectionHeader: {
        title: this.$t('smart-sustainable'),
        paragraph: ''
      }
    }
  }
}
</script>